import { request } from "./request";

/**
 * 获取当前语言的翻译字典 (由后端中间件自动识别)
 */
export const locale = (): Promise<Record<string, string>> => {
  return request(`${(window as any).__LANG_PREFIX__ || "/zh"}/web/i18n`, {
    method: "GET",
  });
};
